import { useParamsContext } from '../../../contexts/ParamsContext';
import { useEstoqueContext } from '../Context';

const navItems = [
    { key: 'overview', label: 'Geral' },
    { key: 'items', label: 'Itens' },
    { key: 'movement', label: 'Movimentar' },
    { key: 'recipes', label: 'Receitas' },
    { key: 'reports', label: 'Relatórios' },
];

export default function EstoqueNav() {
    const { action, setParams } = useParamsContext();
    const { summary } = useEstoqueContext();
    const current = action || 'overview';
    const currentKey = current === 'detail' ? 'items' : current;
    const critical = summary?.criticalCount ?? 0;

    return (
        <nav className="-mx-1 overflow-x-auto px-1" aria-label="Seções do estoque">
            <div className="sf-segmented min-w-[28rem]" role="group">
                {navItems.map((item) => (
                    <button
                        key={item.key}
                        type="button"
                        aria-pressed={currentKey === item.key}
                        onClick={() => setParams({ action: item.key, id: '' })}
                    >
                        {item.label}
                        {item.key === 'overview' && critical > 0 && <span className="sf-segmented-count">{critical}</span>}
                    </button>
                ))}
            </div>
        </nav>
    );
}
